import { render, staticRenderFns } from "./AddPersonalInformation.vue?vue&type=template&id=019f71ba&scoped=true"
import script from "./AddPersonalInformation.vue?vue&type=script&lang=js"
export * from "./AddPersonalInformation.vue?vue&type=script&lang=js"
import style0 from "./AddPersonalInformation.vue?vue&type=style&index=0&id=019f71ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f71ba",
  null
  
)

export default component.exports